import { render, staticRenderFns } from "./DropdownQuestion.vue?vue&type=template&id=624f036d"
import script from "./DropdownQuestion.vue?vue&type=script&lang=js"
export * from "./DropdownQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports